module.exports = __webpack_public_path__ + "static/media/tampico-second.7e433b24.jpg";